// Action Types
export const SUBMIT_COMPETITOR_PROFILE_REQUEST =
  "SUBMIT_COMPETITOR_PROFILE_REQUEST";
export const SUBMIT_COMPETITOR_PROFILE_SUCCESS =
  "SUBMIT_COMPETITOR_PROFILE_SUCCESS";
export const SUBMIT_COMPETITOR_PROFILE_FAILURE =
  "SUBMIT_COMPETITOR_PROFILE_FAILURE";

// Action Creators
export const submitCompetitorProfileRequest = (dimension) => ({
  type: SUBMIT_COMPETITOR_PROFILE_REQUEST,
  payload: dimension,
});

export const submitCompetitorProfileSuccess = (message) => ({
  type: SUBMIT_COMPETITOR_PROFILE_SUCCESS,
  payload: message,
});

export const submitCompetitorProfileFailure = (error) => ({
  type: SUBMIT_COMPETITOR_PROFILE_FAILURE,
  payload: error,
});
